import React from 'react';
import { FormGroup, Input } from 'reactstrap';
import { Translate } from 'react-localize-redux';
import moment from 'moment';

import PropTypes from 'prop-types';

function ExpDate(props) {
  const {
    date,
    handleChange,
    isSubmitted,
    validate,
  } = props;

  return (
    <FormGroup>
      <Input
        id="experienceDate"
        type="date"
        min={moment().subtract('1', 'year').format('YYYY-MM-DD')}
        max={moment().format('YYYY-MM-DD')}
        value={date}
        onChange={handleChange}
      />
      {(!validate() && isSubmitted)
        && (
        <p>
          {' '}
          <Translate id="required" />
        </p>
        )}

    </FormGroup>
  );
}


ExpDate.propTypes = {
  date: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  validate: PropTypes.func.isRequired,
};

export default ExpDate;
